import React from "react";
import servicesLeads from "assets/services-image/services_leads.png";

const Leads = () => {
    return (<div className="services-section">
        <div className="services-section--content">
            <h2>Leads</h2>
            <ul>
                <li>
                    <p><b>Lead Capture:</b> Form for capturing leads from various sources (website, social media, etc).</p>
                </li>
                <li>
                    <p><b>Lead Scoring:</b> Assign scores to prioritize leads based on engagement and potential.</p>
                </li>
                <li>
                    <p><b>Lead Assignment:</b> Automatically assign leads to sales agents based on criteria.</p>
                </li>
                <li>
                    <p><b>Follow-up Reminder:</b> Automated reminder for follow-up action.</p>
                </li>
                <li>
                    <p><b>Lead Nurturing:</b> Email campaigns and workflows to nurture leads.</p>
                </li>
            </ul>
        </div>
        <div className="services-section--image">
            <img src={servicesLeads} alt="Leads"/>
        </div>
    </div>);
};

export default Leads;
